<template>
  <div class="table-by-date-row">
    <div class="table-by-date-header">
      <!-- <h6> {{ data.user.name }}</h6> -->
      <b-button
        variant="primary"
        size="sm"
        @click="reportData()"
      >
        <feather-icon icon="FileTextIcon" class="export-button-icon"/>
        Exportar
      </b-button>
    </div>
    <custom-g-table
      ref="custom-table"
      :fields="fields"
      :items="data.data"
    />
  </div>
</template>
  
<script>

import CustomGTable from '@/views/custom/table/CustomGTable.vue';
import { ref, computed } from "@vue/composition-api";
import AppConstants from '@/appConstants';
import { BButton } from "bootstrap-vue";

export default {

  components: {
    CustomGTable,
    BButton
  },

  props: {
    data: {
      type: Object,
      required: true
    },
  },
  watch: {

  },

  created() {
  },

  setup(props, { emit }) {

    // Variables
    const limit = ref(AppConstants.PAGINATOR_DEFAULT_LIMIT);
    const page = ref(1);

    const fields = [
      {
        field: "date",
        label: "Data",
        sortable: false,
      },
      {
        field: "total",
        label: "Total de Publicações",
        sortable: false,
      },
    ];

    // Computed property
    const totalRows = computed(() => props.data.data.length);

    //Methods
    const onChangePage = (newPage) => {
      page.value = newPage;
      emit('fetch-report', newPage);
    };

    const formatCSV = (value) => {
      if (value == null) return '';
      return `"${value.toString().replace(/"/g, '""')}"`;
    };

    const reportData = () => {
      const csvContent = [
        fields.map(field => formatCSV(field.label)).join(';'),
        ...props.data.data.map(row => 
          fields.map(field => formatCSV(row[field.field])).join(';')
        )
      ].join('\n');

      const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
      
      const link = document.createElement("a");
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", `${props.data.user.name}_report.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    };

    return {
      // Variables
      totalRows,
      limit,
      fields,

      // Methods
      onChangePage,
      reportData
    }
  },
}
</script>

<style>

.table-by-date-row {
  margin-bottom: 60px;
}

.table-by-date-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  align-items: center;
}

.table-by-date-header h6 {
  margin-bottom: 0;
}


</style>
